// Local development fallback
const LOCAL_BASE_URL = 'http://localhost:3030';

// Environment-specific configuration
export const BASE_URL = process.env.REACT_APP_API_BASE_URL ||
                       process.env.STAGING_API_BASE_URL ||
                       LOCAL_BASE_URL;

console.log('DEBUG - Using API BASE_URL:', BASE_URL);

export const AUTH_URL = `${BASE_URL}/auth/login`;
export const VERIFY_URL = `${BASE_URL}/auth/verify`;
export const CHARITIES_URL = `${BASE_URL}/charities`;
export const PLEDGES_URL = `${BASE_URL}/pledges`;
export const USERS_URL = `${BASE_URL}/users`;
// Admin-only platform fee composition (fixed + percentage). GET reads the
// active config; POST persists a new one. See backend README → "Fee Calculation".
export const FEE_CONFIG_URL = `${BASE_URL}/pledges/admin/fee-config`;

